import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import form from '@/components/Admin/form'
import File from '@/components/Admin/File'
import Detail from '@/components/Admin/Detail'
import ImagesFile from '@/components/Admin/ImagesFile'
import Report from '@/components/Admin/Report'
// import Box from '@/components/Admin/Box'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/File', name: 'File', component: File },
    { path: '/home', name: 'Home', component: Home },
    { path: '/form', name: 'form', component: form },
    { path: '/Report', name: 'Report', component: Report },
    { path: '/Detail', name: 'Detail', component: Detail },
    { path: '/ImagesFile', name: 'ImagesFile', component: ImagesFile },
    // { path: '/Box', name: 'Box', component: Box },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js